import { Link } from "react-router-dom";

/**
 * Logo — Maisha Pharma brand mark.
 * Uses the dual-asset approach: full-colour PNG for light backgrounds,
 * bone-coloured variant for dark backgrounds (preserves copper accent).
 */
export const Logo = ({ size = 36, withWordmark = true, color = "ink" }) => {
  const isLight = color === "light";
  const src = isLight ? "/maisha-logo-light.png" : "/maisha-logo.png";
  const height = size;
  // Asset aspect ratio ≈ 1.74:1
  const width = Math.round(size * 1.74);
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group" aria-label="Maisha Pharma — home">
      <img
        src={src}
        alt="Maisha Pharma"
        width={width}
        height={height}
        style={{ height, width: "auto" }}
        className="select-none transition-opacity"
        draggable={false}
      />
    </Link>
  );
};

export default Logo;
